import React from 'react';
import { createPortal } from 'react-dom';

const ENLARGE_FACTOR = 2;

// Fullscreen overlay showing an enlarged image; clicking anywhere closes it.
// `image` is { src, width, height } where width/height are the cell's
// rendered size (px) - the overlay shows it at ENLARGE_FACTOR times that.
const ImageLightbox = ({ image, onClose }) => {
  if (!image) return null;

  const { src, width, height } = image;

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        cursor: 'zoom-out'
      }}
    >
      <img
        src={src}
        alt=''
        onClick={onClose}
        style={{
          width: width ? width * ENLARGE_FACTOR : undefined,
          height: height ? height * ENLARGE_FACTOR : undefined,
          maxWidth: '90vw',
          maxHeight: '90vh',
          objectFit: 'contain',
          boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
          borderRadius: '4px'
        }}
      />
    </div>,
    document.body
  );
};

export default ImageLightbox;
